import removeInfoBarMessage from 'owa-info-bar/lib/actions/removeInfoBarMessage';
import type { ComposeViewState } from 'owa-mail-compose-store';
import clearClassification from 'owa-mail-protection/lib/utils/classification/clearClassification';
import setIRMData from 'owa-mail-protection/lib/actions/rms/setIRMData';
import getEncryptionInfoBarMessageId from 'owa-mail-protection/lib/utils/rms/getEncryptionInfoBarMessageId';
import type RightsManagementLicenseDataType from 'owa-service/lib/contract/RightsManagementLicenseDataType';

export function clearIrmData(
    viewState: ComposeViewState,
    IRMData: RightsManagementLicenseDataType | undefined
) {
    if (IRMData) {
        removeInfoBarMessage(viewState, getEncryptionInfoBarMessageId(IRMData.RmsTemplateId));
        setIRMData(viewState.protectionViewState, null /*IRMData*/);
    }
}

export default function onClearMsgPermssions(viewState: ComposeViewState) {
    const { protectionViewState } = viewState;
    const { classificationViewState, IRMData } = protectionViewState;

    clearClassification(classificationViewState, viewState);
    clearIrmData(viewState, IRMData);
}
